import { render, staticRenderFns } from "./CelebrateDialog.vue?vue&type=template&id=2c064864&scoped=true&"
import script from "./CelebrateDialog.vue?vue&type=script&lang=js&"
export * from "./CelebrateDialog.vue?vue&type=script&lang=js&"
import style0 from "./CelebrateDialog.vue?vue&type=style&index=0&id=2c064864&scoped=true&lang=scss&"
import style1 from "./CelebrateDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c064864",
  null
  
)

export default component.exports